import { render, staticRenderFns } from "./PolicyAreaList.vue?vue&type=template&id=2c7d2afe"
import script from "./PolicyAreaList.js?vue&type=script&lang=js&external"
export * from "./PolicyAreaList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports